import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that restricts MAT pages to farmacia users with Winphar or Sifarma software.
 * Decides on the /auth/me user: after a reload the stored one is the sign-in payload until /auth/me answers.
 */
export const matAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const check = () => {
    if (authService.hasMatAccess()) {
      return true;
    }
    router.navigate(['/home']);
    return false;
  };
  const pending = authService.pendingUserRefresh();
  return pending ? pending.then(check, check) : check();
};
